import { MutationTree } from 'vuex';
import { IMenuHistoryState } from './types';

const mutations: MutationTree<IMenuHistoryState> = {
  reset(state) {
    state.items = [];
  },

  items(state, items) {
    state.items = items;
  },

  setSelectedResultIndex(state, newIndex) {
    state.selectedResultIndex = newIndex;
  },

  setCacheSuffix(state, cacheSuffix) {
    state.cacheSuffix = cacheSuffix;
  },
};

export default mutations;
